// extracted by mini-css-extract-plugin
export default {"ThankYouBox":"ThankYou_ThankYouBox__b7Li1"};